import { RegularExpressions } from "../../../../../assets/regularExpressionAssets";
import { enumSocialMediaPostType } from "../../../../enums";
import { ISocialMediaPostDisplaySpecs } from "../ISocialMediaPostDisplaySpecs";

/**
 * @function deriveDisplaySpecsForPinterest Derives the specs needed to display a Pinterest Social Media Post from a raw reference
 * @param socialMediaPostRawReference The raw reference associated with the Social Media Post (eg, could be a URL or could be an <iframe>)
 */
export function deriveDisplaySpecsForPinterest(socialMediaPostRawReference: string): ISocialMediaPostDisplaySpecs {

  // set default displaySpecs values for Pinterest
  let displaySpecs: ISocialMediaPostDisplaySpecs = { socialMediaPostType: enumSocialMediaPostType.Undefined, url: '', width: '250px', height: '500px' };;

  // execute the regular expression against the url to determine if the socialMediaPostRawReference represents a standard Pinterest Post EmbedUrl
  const matchEmbedUrl: RegExpExecArray | null = RegularExpressions.PinterestPostEmbedUrl.exec(socialMediaPostRawReference);

  // if a match was made for a simple embed url...
  if (matchEmbedUrl && matchEmbedUrl.groups && matchEmbedUrl.groups.embedUrl) {
    // set the specs for displaying the post
    displaySpecs = { socialMediaPostType: enumSocialMediaPostType.Pinterest, url: matchEmbedUrl.groups.embedUrl, width: '250px', height: '500px' };
  } else {
    // execute the regular expression against the url to determine if the url represents a Pinterest IFrame with full specs
    const matchIFrameWithFullSpecs: RegExpExecArray | null = RegularExpressions.PinterestPostIFrameWithFullSpecs.exec(socialMediaPostRawReference);

    // if a match was made for an <iframe>...
    if (matchIFrameWithFullSpecs && matchIFrameWithFullSpecs.groups) {
      // set the Social Media Post Type
      displaySpecs.socialMediaPostType = enumSocialMediaPostType.Pinterest;

      // if the embedUrl is found...
      if (matchIFrameWithFullSpecs.groups.embedUrl) {
        displaySpecs.url = matchIFrameWithFullSpecs.groups.embedUrl;
      }

      // if the id is found...
      if (matchIFrameWithFullSpecs.groups.id) {
        displaySpecs.url = `http://www.pinterest.com/pin/${matchIFrameWithFullSpecs.groups.id}/`;
      }

      // if the 'height' parameter was found, ... 
      if (matchIFrameWithFullSpecs.groups.height) {
        // convert to a number and set value into the displaySpecs.height variable
        displaySpecs.height = parseInt(matchIFrameWithFullSpecs.groups.height);
      }

      // if the 'width' parameter was found, ... 
      if (matchIFrameWithFullSpecs.groups.width) {
        // convert to a number and set value into the displaySpecs.width variable
        displaySpecs.width = parseInt(matchIFrameWithFullSpecs.groups.width);
      }
    }
  }

  return displaySpecs;
}
